var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8964 0.651626C11.9219 2.91465 9.94722 5.15187 7.97269 7.41485C7.53103 7.90349 7.08937 8.41776 6.64769 8.90635C6.49183 9.08645 6.0761 9.72935 5.8162 9.83212C5.40046 10.0122 5.71235 9.98639 5.2705 9.78064C4.7248 9.49776 4.1534 8.72625 3.73766 8.26346C3.19196 7.69771 2.64644 7.1063 2.10079 6.48903C1.45126 5.74337 0.334161 6.82339 1.00958 7.56909C2.10079 8.8034 3.32191 10.3979 4.7248 11.2978C5.94592 12.0693 6.64746 11.2207 7.42676 10.3464C9.94694 7.46627 12.4671 4.58607 14.9873 1.70592C15.6631 0.98588 14.5719 -0.0941322 13.8963 0.65153L13.8964 0.651626Z",
    fill: "#7741DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.6d605d9d.svg";
export { ForwardRef as ReactComponent };